import { useMutation } from '@tanstack/react-query';

import type { JobSummaryType, JobSummaryViewModel } from '../model';
import { toJobSummaryViewModelFromAutoProcessResult } from '../model';

import { jobImprovedSelectionClient } from './client';
import { queryClient } from '@/config/queryClient';
import { QueryKey } from '@/types/query';

const ATS_RAW: JobSummaryType = 'ATS_RAW';

export type UseAutoProcessAtsVacancyParams = {
  job_ats_id: string;
  type: JobSummaryType;
};

export const useAutoProcessAtsVacancy = () => {
  return useMutation({
    mutationKey: [QueryKey.useAutoProcessAtsVacancyJobImprovedSelection],
    mutationFn: async ({ job_ats_id, type }: UseAutoProcessAtsVacancyParams): Promise<JobSummaryViewModel> => {
      if (type !== ATS_RAW) {
        throw new Error('ATS_RAW is the only supported type when auto processing ATS vacancies');
      }
      const { data } = await jobImprovedSelectionClient.autoProcessAtsVacancy({ ats_vacancy_id: job_ats_id });
      if (!data.result?.job_ats_id) {
        throw new Error('Processed vacancy has no ATS ID');
      }
      return toJobSummaryViewModelFromAutoProcessResult(data.result);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.useJobImprovedListQuery] });
    },
  });
};
